import { useMemo } from "react";
import { AnalyticsCampaign } from "../../../types";

export function useDataRead(analyticsData: AnalyticsCampaign[] | undefined) {
  return useMemo(
    () => ({
      data: analyticsData?.map((dataItem, index) => ({
        label: "Read",
        value: dataItem.audienceReached.read.percentage || 0,
        exactValue: dataItem.audienceReached.read.amount,
        backgroundColor: index === 0 ? "rgba(99, 102, 241, 0.5)" : undefined,
      })),
      title: analyticsData?.reduce(
        (acc, curr) => acc + curr.audienceReached.read.amount,
        0
      ),
    }),
    [analyticsData]
  );
}
